import MenuPage from "../menu-page/menu-page";
import { useTranslation } from "react-i18next";
import LinkButton from "../link-button/link-button";
import { FeatureGate } from "../../common/feature-gate/FeatureGate";

const SelectGame = () => {
  const { t } = useTranslation("main", { keyPrefix: "start" });

  return (
    <MenuPage
      titles={[t("headers.default")]}
      subHeaders={[
        t("subheaders.defaultOne"),
        t("subheaders.lineThree"),
        t("subheaders.defaultTwo"),
        t("subheaders.defaultThree"),
      ]}
    >
      <div className={"flex flex-1 flex-col items-center justify-center py-2"}>
        <div className={"flex flex-col items-stretch space-y-4"}>
          <LinkButton size={"4xl"} path={"/play/create"}>
            {t("body.createGame")}
          </LinkButton>
          <LinkButton size={"4xl"} path={"/play/join"}>
            {t("body.enterGame")}
          </LinkButton>
          <LinkButton size={"4xl"} path={"/play/join?audience=true"}>
            {t("body.enterGameAudience")}
          </LinkButton>
        </div>
      </div>
    </MenuPage>
  );
};

export default SelectGame;
